import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";
import updateClassStudentState from './updateClassStudentState';

// remove student from class
//
export default function removeStudentFromClass(classId, studentId) {

  if(typeof classId != "number" || typeof studentId != "number") {
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing or wrong type of params: classId:number, studentId:number')
      })
    })
	}


	return updateClassStudentState(classId, studentId, "not_enrolled");

}



// WEBPACK FOOTER //
// ./src/controllers/controllers/class/removeStudentFromClass.js